import { Col, Descriptions, List, Modal, Row } from 'antd';
import { Fragment, ReactNode } from 'react';
import { PromotionDetail } from '../data';
import { addCommaToNumber } from '@you-go-vn/components';
import moment from 'moment';
import { saleRules } from './ConditionsSetting';
import {
  paymentMethods,
  promotionDiscountTargets,
  promotionDiscountTypes,
  promotionTypes,
} from '..';
import { SaleRuleAtrribute } from '@you-go-vn/enums';

type Props = {
  visible: boolean;
  initialValues: PromotionDetail;
  onCancel: () => void;
  actions: ReactNode;
};
const DetailModal = ({
  visible,
  onCancel,
  initialValues: values,
  actions,
}: Props) => {
  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        footer={actions}
        centered
        width={768}
        zIndex={999}
        destroyOnClose
        title={`Chi tiết Khuyến mãi "${values?.name}"`}
      >
        <Descriptions
          bordered
          column={1}
          size="small"
          labelStyle={{ maxWidth: 435 }}
        >
          <Descriptions.Item label="Tên">{values.name}</Descriptions.Item>
          <Descriptions.Item label="Loại">
            {promotionTypes.find((x) => x.value === values.type)?.label || (
              <i>Chưa cập nhật</i>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Mã khuyến mãi">
            {values.code}
          </Descriptions.Item>
          <Descriptions.Item label="Mô tả">
            {values.description}
          </Descriptions.Item>
          <Descriptions.Item label="Thời gian">
            {moment(values.startsFrom).utc().format('L')} đến{' '}
            {moment(values.endTill).utc().format('L')}
          </Descriptions.Item>
          <Descriptions.Item label="Giá trị được giảm">
            {addCommaToNumber(values.discountAmount || 0)}{' '}
            {promotionDiscountTypes.find((x) => x.value === values.discountType)
              ?.label || <i>Chưa cập nhật</i>}
          </Descriptions.Item>
          <Descriptions.Item label="Giảm tối đa">
            {addCommaToNumber(values.discountMax || 0)} VNĐ
          </Descriptions.Item>
          <Descriptions.Item label="Giảm vào">
            {promotionDiscountTargets.find(
              (x) => x.value === values.discountTarget,
            )?.label || <i>Chưa cập nhật</i>}
          </Descriptions.Item>
          <Descriptions.Item label="YouGo chi trả (% tiền giảm giá)">
            {values.percentageYougo}%
          </Descriptions.Item>
          <Descriptions.Item label="Đối tác chi trả (% tiền giảm giá)">
            {values.percentageMerchant}%
          </Descriptions.Item>
          <Descriptions.Item label="Số lượng mã giảm giá có thể dùng chung">
            {values.numberCanCombined}
          </Descriptions.Item>
          <Descriptions.Item label="Giới hạn số lần sử dụng">
            {values.limitUsesPerCode}
          </Descriptions.Item>
          <Descriptions.Item label="Giới hạn số lần sử dụng trong ngày">
            {values.limitUsesPerCodeInDate}
          </Descriptions.Item>
          <Descriptions.Item label="Giới hạn số lần sử dụng của mỗi khách hàng">
            {values.limitUsesPerUser}
          </Descriptions.Item>
          <Descriptions.Item label="Giới hạn số lần sử dụng của mỗi khách hàng trong ngày">
            {values.limitUsesPerCodeInDate}
          </Descriptions.Item>
          <Descriptions.Item label="Chỉ dùng trong những nhà hàng có chương trình khuyến mãi">
            {values.onlyInPromotion ? 'Đúng' : 'Sai'}
          </Descriptions.Item>
          <Descriptions.Item label="Hiện trong phần gợi ý mã giảm giá">
            {values.isPublic ? 'Có' : 'Không'}
          </Descriptions.Item>
          <Descriptions.Item label="Cho phép sử dụng">
            {values.isActive ? 'Có' : 'Không'}
          </Descriptions.Item>
          <Descriptions.Item label="Quy tắc giảm giá">
            {values.rules
              ? values.rules.map((x, i) => {
                  return (
                    <Fragment key={i}>
                      {i > 0 && (
                        <div style={{ alignSelf: 'start', padding: '4px 0' }}>
                          Hoặc:
                        </div>
                      )}
                      <List
                        bordered
                        dataSource={x}
                        renderItem={(item) => {
                          const saleRule = saleRules.find(
                            (x) => x.value === item.attribute,
                          );
                          return (
                            <List.Item
                              style={{ paddingLeft: 8, paddingRight: 8 }}
                            >
                              <>
                                <Row
                                  key={i}
                                  style={{
                                    width: '100%',
                                    textAlign: 'left',
                                  }}
                                  gutter={8}
                                  align="middle"
                                >
                                  <Col
                                    span={9}
                                    style={{
                                      borderRight: '1px solid #0000001a',
                                    }}
                                  >
                                    {saleRule?.label}
                                  </Col>
                                  <Col
                                    span={5}
                                    style={{
                                      borderRight: '1px solid #0000001a',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {
                                      saleRule?.operator.find(
                                        (x) => x.value === item.operator,
                                      )?.label
                                    }
                                  </Col>
                                  <Col
                                    span={10}
                                    style={{
                                      textAlign: 'right',
                                    }}
                                  >
                                    {item.attribute ===
                                    SaleRuleAtrribute.PAYMENT_METHOD
                                      ? paymentMethods.find(
                                          (x) => x.value === item.value,
                                        )?.label
                                      : item.attribute ===
                                          SaleRuleAtrribute.BASE_TOTAL ||
                                        item.attribute ===
                                          SaleRuleAtrribute.SHIPPING_FEE
                                      ? addCommaToNumber(
                                          typeof item.value === 'number'
                                            ? item.value
                                            : parseInt(item.value),
                                        )
                                      : item.value}{' '}
                                    {saleRule?.unit}
                                  </Col>
                                </Row>
                              </>
                            </List.Item>
                          );
                        }}
                      />
                    </Fragment>
                  );
                })
              : 'Không có quy tắc nào'}
          </Descriptions.Item>
          {/* <RowDetail> */}
          {/*   <Label>Cho phép nhà hàng tham gia chương trình khuyến mãi</Label> */}
          {/*   <Value>{values.canJoinPromotion ? 'Có' : 'Không'}</Value> */}
        </Descriptions>
      </Modal>
    </>
  );
};

export default DetailModal;
